import React from 'react'; // eslint-disable-line

const GeneralSection = (props) => {
    return (
        <div
            className={`general-section ${props.sectionClass}`}
            data-qa={`general-section-for-${props.dataqa}`}
        >
            <h2
                data-qa={`general-section-header-for-${props.dataqa}`}
                className="section-name"
            >
                {props.name}
            </h2>
            {props.children}
        </div>
    );
};

export default GeneralSection;
